/* eslint-disable */
import React from "react";

import Modal from "../../components/ui/Modal";
import { MailIcon, MobileIcon, SuccessIcon } from "../../assets/Icons";
import clsx from "clsx";
import { getSignedStatus, sendA2Form } from "../../services/reviewPage";
import ErrorField from "../../components/ui/ErrorField";
import IReviewPage from "./ReviewPage";
import Button from "../../components/ui/Button";
import { Mixpanel } from "../../constants/mixpanel";
import CopyLink from "../../assets/svg/CopyIcon.svg";

export const EsignModal: React.FC<IReviewPage.EsignModalProps> = ({
  isEsignModal,
  setIsEsignModal,
  modalTitle,
  handleDoLaterA2Form,
  handleA2Form,
  handleLinkSent,
  viewA2Form,
  isViewingA2Form,
  //setIsViewingA2Form,
  A2errorMessage,
  A2seterrorMessage,
  a2Link,
}) => {
  const [mobileActive, setMobileActive] = React.useState<boolean>(false);
  const [mailActive, setMailActive] = React.useState<boolean>(false);
  const [step, setStep] = React.useState<string>("1");
  const [error, setError] = React.useState<string>("");
  const [linkSent, setLinkSent] = React.useState<boolean>(false);
  const [isLinkedCopied, setIsLinkedCopied] = React.useState<boolean>(false);
  const [isDisabled, setIsDisabled] = React.useState({
    mobileLoader: false,
    emailLoader: false,
  });
  const [isTimeUp, setIsTimeUp] = React.useState(false);
  const [timeLeft, setTimeLeft] = React.useState(60);
  const [clickedTime, setClickedTime] = React.useState<number>(0);

  React.useEffect(() => {
    let interval: any;
    if (isEsignModal) {
      interval = setInterval(() => {
        handleEsignedStatus();
      }, 3000);
    }
    return () => clearInterval(interval);
  }, [isEsignModal, step]);

  React.useEffect(() => {
    if (timeLeft !== 0&&clickedTime>=2) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime: any) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            setIsTimeUp(true);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [timeLeft,clickedTime]);

  const handleEsignedStatus = () => {
    const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
    if (isEsignModal) {
      if (step === "2") {
        getSignedStatus({
          userId: vendorUserKey,
        })
          .then((response) => {
            setError("");
            if (response?.data?.signed) {
              if (step === "2") {
                setStep("3");
              }
            }
          })
          .catch((error) => {
            setError(error?.response?.data?.error?.type);
          });
      }
    }
  };

  const handleMobileNumber = () => {
    Mixpanel.track("Sendlink_mobile_online");
    clickedTime<2?setTimeLeft(60): clickedTime > 2 && timeLeft === 0 && setTimeLeft(60);
    setIsTimeUp(false);
    setClickedTime(clickedTime + 1);
    setMobileActive(true);
    setMailActive(false);
    setIsDisabled((prev) => ({ ...prev, mobileLoader: true }));
    const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
    sendA2Form({
      sendType: "sms",
      userId: vendorUserKey,
      transactionNumber: null,
      resend: false,
    })
      .then(() => {
        setStep("2");
        setError("");
        setLinkSent(true);
      })
      .catch((error) => {
        setError(error?.response?.data?.error?.type);
        setTimeout(() => {
          setError("");
        }, 3000);
      })
      .finally(() =>
        setIsDisabled((prev) => ({ ...prev, mobileLoader: false }))
      );
  };

  const handleMail = () => {
    Mixpanel.track("Sendlink_email_online");
    setMobileActive(false);
    clickedTime<2?setTimeLeft(60): clickedTime > 2 && timeLeft === 0 && setTimeLeft(60);
    setIsTimeUp(false);
    setMailActive(true);
    setClickedTime(clickedTime + 1);
    setIsDisabled((prev) => ({ ...prev, emailLoader: true }));
    const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
    sendA2Form({
      sendType: "Mail",
      userId: vendorUserKey,
      transactionNumber: null,
      resend: false,
    })
      .then(() => {
        setStep("2");
        setError("");
        setLinkSent(true);
      })
      .catch((error) => {
        setError(error?.response?.data?.error?.type);
        setTimeout(() => {
          setError("");
        }, 3000);
      })
      .finally(() =>
        setIsDisabled((prev) => ({ ...prev, emailLoader: false }))
      );
  };

  const buttons = [
    {
      text: "Mobile number",
      onclickHandle: handleMobileNumber,
      icon: <MobileIcon />,
      loader: isDisabled?.mobileLoader,
      css: mobileActive ? "bg-[#282A30] text-white" : "bg-[#F1F4FF]",
    },
    {
      text: "Mail",
      onclickHandle: handleMail,
      icon: <MailIcon />,
      loader: isDisabled?.emailLoader,
      css: mailActive ? "bg-[#282A30] text-white" : "bg-[#F1F4FF]",
    },
  ];

  const copyLink = (a2Link: string) => {
    setIsLinkedCopied(true);
    navigator.clipboard.writeText(a2Link);
    setTimeout(() => {
      setIsLinkedCopied(false);
    }, 3000);
  };

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}.${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };


  return (
    <Modal
      modalClass="!p-0 md:pr-11 flex p-0 flex-col !rounded lg:!w-6/12 !w-full"
      headerClass="!mt-0 items-center text-white sticky h-24 pr-4 pl-[42%] bg-primary font-bold text-2xl"
      visible={isEsignModal}
      header={modalTitle ? modalTitle : "Sign A2 Form"}
      closeHandler={() => {
        A2seterrorMessage("");
        if (linkSent) {
          handleLinkSent && handleLinkSent();
        }
        setIsEsignModal(false), setMobileActive(false), setMailActive(false);
      }}
    >
      {step === "1" && (
        <div>
          <div className="flex flex-col items-center my-8">
            <h1
              onClick={(e) => {
                if (viewA2Form) {
                  viewA2Form(e);
                }
              }}
              className="text-[15px] py-4 lg:text-[20px] font-semibold text-primary first-letter cursor-pointer"
            >
              View A2 Form{" "}
            </h1>
            <div
              id="a2-form-error-message"
              className="flex flex-col mt-2 w-full"
            >
              {A2errorMessage && (
                <div className=" flex flex-col px-4 py-2 mb-0 text-m text-center text-red-600">
                  {A2errorMessage}
                </div>
              )}
            </div>
            {isViewingA2Form && (
              <div className="flex justify-center items-center mt-2">
                <div
                  className="border-t-4 border-blue-500 rounded-full animate-spin w-8 h-8 border-4"
                  role="status"
                ></div>
                <span className="ml-3 text-primary">Opening A2 form...</span>
              </div>
            )}
            <div className="flex w-full justify-center items-center">
              <h1 className="font-semibold text-[20px]">Receive link on</h1>
              <button
                onClick={() => a2Link && copyLink(a2Link)}
                className="flex justify-center items-center pl-4"
              >
                <span
                  className={`text-xs font-semibold ${
                    isLinkedCopied ? "text-green-500" : "text-[#0F5BF1]"
                  }`}
                  style={{ transitionDuration: "300ms" }}
                >
                  {isLinkedCopied ? "Link Copied" : "Copy Link"}
                </span>
                <img className="pl-2" src={CopyLink} alt="copy-link" />
              </button>
            </div>
            {mailActive ||
              (mobileActive && (
                <span className="text-[10px] font-normal text-[#949494]">
                  Received link will be active for 5 mins
                </span>
              ))}

            <div className="flex items-center justify-center w-full py-4">
              {buttons?.map((buttons, index) => (
                <Button
                  isLoading={buttons?.loader}
                  onClickHandler={buttons?.onclickHandle}
                  key={index}
                  className={clsx(
                    "flex min-w-[220px] cursor-pointer justify-start mx-4 items-center rounded-lg p-5"
                  )}
                  bgColor={buttons?.css}
                >
                  {buttons?.icon}
                  <h1 className="pl-3 text-[20px]">{buttons?.text}</h1>
                </Button>
              ))}
            </div>
            {mailActive ||
              (mobileActive && (
                <span className="text-[15px] w-1/2 text-center font-normal text-[#969696]">
                  A link has been sent to your registered mobile number. Please
                  draw your signature and submit the same
                </span>
              ))}
            {/* <div className="w-64 h-auto p-5">
                <Button
                  isLoading={isDisabled.mobileLoader}
                  onClickHandler={() => handleMobileNumber()}
                  className={clsx(
                    "flex justify-between items-center rounded-lg p-5",
                    mobileActive
                      ? "bg-primary-300 text-white"
                      : "bg-primary-800"
                  )}
                >
                  <MobileIcon />
                  <h1 className="ml-3 text-[20px]">Mobile Number</h1>
                </Button>
              </div>
              <div className="w-64 h-auto p-5">
                <Button
                  isLoading={isDisabled.emailLoader}
                  onClickHandler={() => handleMail()}
                  className={clsx(
                    "flex justify-between items-center rounded-lg p-5",
                    mailActive ? "bg-primary-300 text-white" : "bg-primary-800"
                  )}
                >
                  <MailIcon />
                  <h1 className="text-[20px]">Mail</h1>
                </Button>
              </div> */}
            <div
              onClick={handleDoLaterA2Form}
              className="mt-10 flex flex-col items-center cursor-pointer"
            >
              <h1 className="text-primary font-semibold text-[20px]">
                Do it later
              </h1>
              <ErrorField errorMessage={error} />
            </div>
          </div>
        </div>
      )}
      {step === "2" && (
        <div className="flex flex-col items-center py-10">
          <div className="w-2/5 mb-10">
            {mobileActive ? (
              <h1 className="text-center text-[15px] lg:text-[20px] text-primary font-semibold">
                A link has been sent to your registered mobile number. Please
                draw your signature and submit the same
              </h1>
            ) : (
              <h1 className="text-center text-[15px] lg:text-[20px] text-primary font-semibold">
                A link has been sent to your registered email Id. Please draw
                your signature and submit the same
              </h1>
            )}
          </div>
          <div className="mb-10">
            <h1 className="text-[15px] lg:text-[20px] font-semibold">
              Note- Please draw your signature as on your PAN card
            </h1>
          </div>
          <div className="mb-5">
            <h1 className="text-[15px] lg:text-[20px] font-semibold">
              Awaiting your signature.
            </h1>
          </div>
          <div className="flex space-x-2 animate-pulse mb-10">
            <div className="w-3 h-3 bg-gray-500 rounded-full"></div>
            <div className="w-3 h-3 bg-gray-500 rounded-full"></div>
            <div className="w-3 h-3 bg-gray-500 rounded-full"></div>
          </div>
          {clickedTime > 2 && !isTimeUp && (
            <div className="w-full text-center">
              <span className="font-semibold text-[12.2px] ">
                {formatTime(timeLeft)}
              </span>
            </div>
          )}
          <Button
            // onClickHandler={mobileActive ? handleMobileNumber : handleMail}
            onClickHandler={() => {
              setStep("1");
              setIsDisabled((prev) => ({
                ...prev,
                mobileLoader: false,
                emailLoader: false,
              }));
              setMobileActive(false);
              setMailActive(false);
            }}
            disabled={clickedTime > 2 && !isTimeUp}
            isLoading={
              mobileActive ? isDisabled?.mobileLoader : isDisabled?.emailLoader
            }
            bgColor={
              clickedTime > 2 && !isTimeUp ? "bg-gray-600" : "bg-primary"
            }
            className={`border border-primary text-white font-semibold py-2 px-4 rounded-full text-[15px] lg:text-[20px]`}
          >
            Resend link
          </Button>
        </div>
      )}

      {step === "3" && (
        <div className="flex flex-col items-center py-10">
          <div className="mb-7">
            <h1 className="text-[20px] lg:text-[25px] font-bold">
              Your form has been signed
            </h1>
          </div>
          <div className="mb-8">
            <h1 className="text-[15px] lg:text-[20px] font-semibold">
              Thanks for completion!
            </h1>
          </div>
          <div className="mb-5">
            <SuccessIcon />
          </div>
          <div className="mb-5">
            <h1
              onClick={(e) => handleA2Form && handleA2Form(e)}
              className="cursor-pointer text-[15px] lg:text-[20px] text-primary font-bold"
            >
              Download A2
            </h1>
          </div>
          <div>
            <h1
              onClick={() => {
                setIsEsignModal(false, setStep("1"));
              }}
              className="cursor-pointer text-[15px] lg:text-[20px] text-primary font-bold"
            >
              Go Back
            </h1>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default EsignModal;
